import { COMPANY_TYPE_LABELS } from "@/dossiers/companyLabels";
import {
  RootCompanyResourceCompanyOutputJsonldType as CompanyType,
  type RootCompanyResourceCompanyOutputJsonld,
} from "@/lib/api/generated/model";

/** Domain seam for a Root company, the platform-wide master record. */
export type RootCompany = RootCompanyResourceCompanyOutputJsonld;

/** A trade name ("handelsnaam") of a root company. */
export type RootCompanyBrand = RootCompany["brands"][number];

export const COMPANY_TYPE_OPTIONS: readonly {
  readonly value: RootCompany["type"];
  readonly label: string;
}[] = Object.values(CompanyType).map((value) => ({
  value,
  label: COMPANY_TYPE_LABELS[value],
}));

export function companyTypeLabel(type: RootCompany["type"]): string {
  return COMPANY_TYPE_LABELS[type];
}

/** Display lines of an address; empty for a missing or all-null embeddable. */
export function addressLines(address: RootCompany["address"]): string[] {
  if (!address || address.empty) return [];
  return [
    [
      address.street,
      [address.streetNumber, address.streetNumberAddition]
        .filter(Boolean)
        .join(""),
    ]
      .filter(Boolean)
      .join(" "),
    [address.postalCode, address.city].filter(Boolean).join(" "),
  ].filter(Boolean);
}
